/**
 * Translation Directive
 * Takes a slug and returns the localized text associated with the slug from Contentful.
 * All Contentful data is coming from the current state of the redux store.
 */

module.exports = /* @ngInject */
() => {
    const directive = {
        restrict: 'E',
        scope: {
            slug: '@',
            container: '@',
            params: '@'
        },
        template: '{{ t.model.localizedText }}',
        controller: TranslationController,
        controllerAs: 't',
        bindToController: true
    };
    return directive;
};

/*@ngInject*/
function TranslationController(
    $rootScope,
    $scope,
    TranslationService
) {

    const m = this.model = {
        slug: this.slug,
        container: this.container || 'chromeLocalization',
        params: $scope.$eval(this.params),
        localizedText: ''
    };

    TranslationService.getTranslation(m.slug, m.container, m.params)
        .then((value) => {
            m.localizedText = TranslationService.interpolateValues(value, m.params);
        });
}
